import { render } from "./SubmissionsView.vue?vue&type=template&id=37f0790d&ts=true"
import script from "./SubmissionsView.vue?vue&type=script&lang=ts"
export * from "./SubmissionsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__